import { capitalize } from 'lodash-es';
import { ThesaurusApiTranslation } from '../../records/entities/metadata/metadata.entity';

export interface ApiThesaurusConcept {
    Uri: string;
    Breadcrumbs: ThesaurusApiTranslation[];
    PreferredLabels: ThesaurusApiTranslation[];
    AlternativeLabels: ThesaurusApiTranslation[];
    Broader: string[];
    BroaderTransitive: string[];
    Narrower: string[];
    Selectable: boolean;
}

export interface ThesaurusConceptReference {
    Uri: string;
    [key: string]: string;
}

export function isThesaurusConceptReference(obj: any): obj is ThesaurusConceptReference {
    const typedObj: ThesaurusConceptReference = obj as ThesaurusConceptReference;
    return typedObj.Uri !== undefined;
}

export function isApiThesaurusConcept(obj: any): obj is ApiThesaurusConcept {
    const typedObj: ApiThesaurusConcept = obj as ApiThesaurusConcept;

    return (
        typedObj.Uri !== undefined &&
        (typedObj.Breadcrumbs !== undefined ||
            typedObj.PreferredLabels !== undefined ||
            typedObj.AlternativeLabels !== undefined ||
            typedObj.Broader !== undefined ||
            typedObj.BroaderTransitive !== undefined ||
            typedObj.Narrower !== undefined ||
            typedObj.Selectable !== undefined)
    );
}

export function apiThesaurusConceptToReference(apiConcept: ApiThesaurusConcept): ThesaurusConceptReference {
    const lang: Record<string, string> = apiConcept.PreferredLabels.reduce((acc, curr) => {
        // MED-4134: Fall back to Breadcrumbs if PreferredLabels is empty
        // For some reason API does not always provide the PreferredLabels for root concepts
        const label: string =
            curr.Label.length > 0
                ? curr.Label
                : apiConcept.Breadcrumbs.find(broadLabel => broadLabel.Lang === curr.Lang)?.Label || '';

        // Filter out empty labels because backend does same thing on record-data
        // This is to ensure matching of concepts in the selection lists
        if (label === '') {
            return acc;
        }
        return {
            ...acc,
            [capitalize(curr.Lang.toLowerCase())]: label
        };
    }, {});

    const conceptReference: ThesaurusConceptReference = {
        Uri: apiConcept.Uri,
        ...lang
    };

    return conceptReference;
}
